import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-admisiones',
  templateUrl: './loading-admisiones.component.html',
  styleUrls: ['./loading-admisiones.component.css']
})
export class LoadingAdmisionesComponent implements OnInit {

  @Input() isLoading = true;
  @Input() title = 'Cargando comisiones';
  @Input() message = 'Por favor espere un momento.';

  constructor() { }

  ngOnInit(): void {
  }

}
